import { Link } from 'react-router-dom';
import { useEnquiryModal } from '@/hooks/useEnquiryModal';

const footerLinks = {
  quickLinks: [
    { label: 'Home', href: '/' },
    { label: 'Products', href: '/products' },
    { label: 'About Us', href: '/about' },
    { label: 'Certificates', href: '/certificates' },
    { label: 'Gallery', href: '/gallery' },
    { label: 'Bulk Supply', href: '/bulk-supply' },
    { label: 'Contact', href: '/contact' },
  ],
  contact: {
    address: '248, Village Haiderpur, Shamli-Panipat Marg, Kairana, Shamli, Uttar Pradesh, India – 247774',
    phone: '+91 9084756574',
    email: 'basharatrahi8043@gmail.com',
  },
};

export default function Footer() {
  const { openEnquiry } = useEnquiryModal();
  return (
    <footer className="bg-primary-950 text-background-50">
      {/* Top Section */}
      <div className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-4 group">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center transition-transform duration-300 group-hover:scale-105">
                <i className="ri-plant-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading font-bold text-lg text-background-50 whitespace-nowrap">
                Bassi Enterprises
              </span>
            </Link>
            <p className="text-background-50/60 text-sm leading-relaxed mb-5">
              Fresh Fruits & Vegetables Supplier. Quality produce with reliable supply for businesses across India.
            </p>
            <div className="flex items-center gap-3">
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary-800/50 rounded-full text-xs font-medium text-primary-300 border border-primary-700/30 whitespace-nowrap">
                <i className="ri-shield-check-line text-sm"></i>
                FSSAI Registered
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary-800/50 rounded-full text-xs font-medium text-primary-300 border border-primary-700/30 whitespace-nowrap">
                <i className="ri-government-line text-sm"></i>
                MSME Registered
              </span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-semibold text-sm uppercase tracking-wider text-background-50/40 mb-5">
              Quick Links
            </h4>
            <ul className="space-y-3">
              {footerLinks.quickLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-background-50/70 hover:text-primary-300 text-sm transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading font-semibold text-sm uppercase tracking-wider text-background-50/40 mb-5">
              Contact Us
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-2-line text-primary-400 text-lg mt-0.5"></i>
                <span className="text-background-50/70 text-sm leading-relaxed">
                  {footerLinks.contact.address}
                </span>
              </li>
              <li>
                <a
                  href="tel:+919084756574"
                  className="flex items-center gap-3 text-background-50/70 hover:text-primary-300 text-sm transition-colors duration-200"
                >
                  <i className="ri-phone-line text-primary-400 text-lg"></i>
                  {footerLinks.contact.phone}
                </a>
              </li>
              <li>
                <a
                  href="mailto:basharatrahi8043@gmail.com"
                  className="flex items-center gap-3 text-background-50/70 hover:text-primary-300 text-sm transition-colors duration-200"
                >
                  <i className="ri-mail-line text-primary-400 text-lg"></i>
                  {footerLinks.contact.email}
                </a>
              </li>
            </ul>
          </div>

          {/* CTA Column */}
          <div>
            <h4 className="font-heading font-semibold text-sm uppercase tracking-wider text-background-50/40 mb-5">
              Get In Touch
            </h4>
            <p className="text-background-50/60 text-sm mb-5 leading-relaxed">
              Need bulk fresh produce supply? Reach out to us today for competitive pricing and reliable delivery.
            </p>
            <button
              onClick={() => openEnquiry()}
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-400 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-fill text-lg"></i>
              WhatsApp Us
            </button>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-primary-800/50">
        <div className="w-full px-4 md:px-6 lg:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-background-50/40 text-xs">
            &copy; {new Date().getFullYear()} Bassi Enterprises. All Rights Reserved.
          </p>
          <div className="flex items-center gap-1.5">
            <span className="text-background-50/40 text-xs">FSSAI</span>
            <span className="w-1 h-1 rounded-full bg-background-50/20"></span>
            <span className="text-background-50/40 text-xs">MSME</span>
            <span className="w-1 h-1 rounded-full bg-background-50/20"></span>
            <span className="text-background-50/40 text-xs">GST Registered</span>
          </div>
        </div>
      </div>
    </footer>
  );
}